import React from 'react';
import { debounce } from 'lodash';
import useTimeStore from '../ZustandProvider';

const ExportProviderMap = ({
  drawGeometriesNotes,
  drawGeometriesTemplates,
  currentLocation,
  drawToDownload,
  gotoLocation,
  mapbol,
  mapCenter,
  goToCoordinatesFunction
}) => {
  const allCoordsAnnotations = useTimeStore(state => state.allCoordsAnnotations);
  const boton1 = useTimeStore(state => state.boton1);
  const boton2 = useTimeStore(state => state.boton2);
  const checkCenterAnnotation = useTimeStore(state => state.checkCenterAnnotation);
  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const coordinatesAnnotations = useTimeStore(state => state.coordinatesAnnotations);
  const coordinatesTrackVideo = useTimeStore(state => state.coordinatesTrackVideo);
  const coordinatesVideoPoint = useTimeStore(state => state.coordinatesVideoPoint);
  const coordsAnnotationTemplate = useTimeStore(state => state.coordsAnnotationTemplate);
  const geometryConfig = useTimeStore(state => state.geometryConfig);
  const goToCoordinates = useTimeStore(state => state.goToCoordinates);
  const isNotesVideoEditor = useTimeStore(state => state.isNotesVideoEditor);
  const setDataToSend = useTimeStore(state => state.setDataToSend);
  const setCenterMap = useTimeStore(state => state.setCenterMap);
  const setCoordOnMap = useTimeStore(state => state.setCoordOnMap);
  const setCoordinatesAnnotations = useTimeStore(state => state.setCoordinatesAnnotations);
  const setGoToCoordinates = useTimeStore(state => state.setGoToCoordinates);
  const setProyectedPointTrackVideo = useTimeStore(state => state.setProyectedPointTrackVideo);

  React.useEffect(() => {
    if (mapbol) {
      setTimeout(() => {
        gotoLocation();
      }, 120);
    }
  }, [boton1]);
  React.useEffect(() => {
    if (mapbol) {
      setTimeout(() => {
        currentLocation(false);
      }, 120);
    }
  }, [boton2]);
  React.useEffect(() => {
    if (mapbol) {
      setTimeout(() => {
        setCenterMap(mapCenter);
      }, 120);
    }
  }, [mapCenter]);

  const debounced = React.useCallback(
    debounce(
      (
        allCoordsProp,
        coordProp,
        checkProp,
        coordOnMapProp,
        trackProp,
        isNotesEditor,
        setCoordOnMapProp,
        setCoordProp,
        setPropProy,
        coordsVideoPoint
      ) => {
        drawGeometriesNotes(
          allCoordsProp,
          coordProp,
          checkProp,
          coordOnMapProp,
          trackProp,
          isNotesEditor,
          setCoordOnMapProp,
          setCoordProp,
          setPropProy,
          coordsVideoPoint
        );
      }
    ),
    []
  );

  React.useEffect(() => {
    if (mapbol) {
      debounced(
        allCoordsAnnotations,
        coordinatesAnnotations,
        checkCenterAnnotation,
        coordOnMap,
        coordinatesTrackVideo,
        isNotesVideoEditor,
        setCoordOnMap,
        setCoordinatesAnnotations,
        setProyectedPointTrackVideo,
        coordinatesVideoPoint
      );
    }
  }, [
    coordinatesAnnotations,
    allCoordsAnnotations,
    checkCenterAnnotation,
    coordinatesTrackVideo,
    isNotesVideoEditor
  ]);

  React.useEffect(() => {
    if (mapbol) {
      drawGeometriesTemplates(coordsAnnotationTemplate);
    }
  }, [coordsAnnotationTemplate]);

  React.useEffect(() => {
    if (mapbol) {
      drawToDownload({
        geometryConfig,
        setDataToSend,
        setCoordOnMap
      });
    }
  }, [geometryConfig]);

  React.useEffect(() => {
    if (mapbol) {
      goToCoordinatesFunction({ geometryConfig, goToCoordinates, setGoToCoordinates });
    }
  }, [goToCoordinates]);
  return false;
};

export default ExportProviderMap;
